export const options = [
  { value: 'javascript', label: 'JavaScript' },
  { value: 'python', label: 'Python' },
  { value: 'java', label: 'Java' },
  { value: 'csharp', label: 'C#' },
  { value: 'cpp', label: 'C++' },
  { value: 'ruby', label: 'Ruby' },
  { value: 'php', label: 'PHP' },
  { value: 'typescript', label: 'TypeScript' },
  { value: 'swift', label: 'Swift' },
  { value: 'kotlin', label: 'Kotlin' },
  { value: 'go', label: 'Go' },
  { value: 'rust', label: 'Rust' },
  { value: 'scala', label: 'Scala' },
  { value: 'perl', label: 'Perl' },
  { value: 'r', label: 'R' },
  { value: 'dart', label: 'Dart' },
  { value: 'clojure', label: 'Clojure' },
  { value: 'haskell', label: 'Haskell' },
  { value: 'lua', label: 'Lua' },
  { value: 'groovy', label: 'Groovy' },
  { value: 'html', label: 'HTML' },
  { value: 'css', label: 'CSS' },
  { value: 'bootstrap', label: 'Bootstrap' },
  { value: 'jquery', label: 'jQuery' },
  { value: 'angular', label: 'Angular' },
  { value: 'react', label: 'React' },
  { value: 'vuejs', label: 'Vue.js' },
  { value: 'emberjs', label: 'Ember.js' },
  { value: 'svelte', label: 'Svelte' },
  { value: 'backbonejs', label: 'Backbone.js' },
  { value: 'nextjs', label: 'Next.js' },
  { value: 'nuxtjs', label: 'Nuxt.js' },
  { value: 'aspnet', label: 'ASP.NET' },
  { value: 'jsp', label: 'JSP' },
  { value: 'androidsdk', label: 'Android SDK' },
  { value: 'iossdk', label: 'iOS SDK' },
  { value: 'flutter', label: 'Flutter' },
  { value: 'reactnative', label: 'React Native' },
  { value: 'xamarin', label: 'Xamarin' },
  { value: 'apachecordova', label: 'Apache Cordova' },
  { value: 'ionic', label: 'Ionic' },
  { value: 'kotlinmultiplatform', label: 'Kotlin Multiplatform' },
  { value: 'swiftui', label: 'Swift UI' },
  { value: 'nodejs', label: 'Node.js' },
{ value: 'django', label: 'Django' },
{ value: 'flask', label: 'Flask' },
{ value: 'rubyonrails', label: 'Ruby on Rails' },
{ value: 'laravel', label: 'Laravel' },
{ value: 'springboot', label: 'Spring Boot' },
{ value: 'expressjs', label: 'Express.js' },
{ value: 'aspnetcore', label: 'ASP.NET Core' },
{ value: 'phoenix', label: 'Phoenix' },
{ value: 'gofiber', label: 'GoFiber' },
// Database Management
{ value: 'mysql', label: 'MySQL' },
{ value: 'postgresql', label: 'PostgreSQL' },
{ value: 'mongodb', label: 'MongoDB' },
{ value: 'sqlite', label: 'SQLite' },
{ value: 'oracledb', label: 'Oracle DB' },
{ value: 'microsoftsqlserver', label: 'Microsoft SQL Server' },
{ value: 'cassandra', label: 'Cassandra' },
{ value: 'redis', label: 'Redis' },
{ value: 'elasticsearch', label: 'Elasticsearch' },
{ value: 'neo4j', label: 'Neo4j' },
// Cloud Computing
{ value: 'aws', label: 'AWS' },
{ value: 'azure', label: 'Azure' },
{ value: 'googlecloudplatform', label: 'Google Cloud Platform' },
{ value: 'ibmcloud', label: 'IBM Cloud' },
{ value: 'oraclecloud', label: 'Oracle Cloud' },
{ value: 'salesforce', label: 'Salesforce' },
{ value: 'heroku', label: 'Heroku' },
{ value: 'digitalocean', label: 'DigitalOcean' },
{ value: 'linode', label: 'Linode' },
{ value: 'vercel', label: 'Vercel' },
// DevOps and CI/CD
{ value: 'docker', label: 'Docker' },
{ value: 'kubernetes', label: 'Kubernetes' },
{ value: 'jenkins', label: 'Jenkins' },
{ value: 'gitlabcicd', label: 'GitLab CI/CD' },
{ value: 'travisci', label: 'Travis CI' },
{ value: 'circleci', label: 'CircleCI' },
{ value: 'azuredevops', label: 'Azure DevOps' },
{ value: 'awscodesuite', label: 'AWS CodePipeline' },
{ value: 'terraform', label: 'Terraform' },
{ value: 'ansible', label: 'Ansible' },
{ value: 'puppet', label: 'Puppet' },
{ value: 'chef', label: 'Chef' },
 // Version Control
 { value: 'git', label: 'Git' },
 { value: 'subversion', label: 'Subversion (SVN)' },
 { value: 'mercurial', label: 'Mercurial' },
 { value: 'cvs', label: 'CVS' },
 { value: 'perforce', label: 'Perforce' },
 // Security
 { value: 'owasp', label: 'OWASP' },
 { value: 'burpsuite', label: 'Burp Suite' },
 { value: 'nessus', label: 'Nessus' },
 { value: 'metasploit', label: 'Metasploit' },
 { value: 'wireshark', label: 'Wireshark' },
 { value: 'nmap', label: 'Nmap' },
 { value: 'kalilinux', label: 'Kali Linux' },
 { value: 'zap', label: 'ZAP' },
 // Machine Learning / Deep Learning
 { value: 'tensorflow', label: 'TensorFlow' },
 { value: 'pytorch', label: 'PyTorch' },
 { value: 'keras', label: 'Keras' },
 { value: 'scikitlearn', label: 'Scikit-learn' },
 { value: 'pandas', label: 'Pandas' },
 { value: 'numpy', label: 'NumPy' },
 { value: 'matplotlib', label: 'Matplotlib' },
 { value: 'r', label: 'R' },
 { value: 'sas', label: 'SAS' },
 { value: 'spss', label: 'SPSS' },
 // Big Data Technologies
 { value: 'apachehadoop', label: 'Apache Hadoop' },
 { value: 'apachespark', label: 'Apache Spark' },
 { value: 'apachekafka', label: 'Apache Kafka' },
 { value: 'apacheflink', label: 'Apache Flink' },
 { value: 'apachestorm', label: 'Apache Storm' },
 { value: 'apachehive', label: 'Apache Hive' },
 { value: 'apachepig', label: 'Apache Pig' },
 { value: 'presto', label: 'Presto' },
 // Blockchain Development
 { value: 'ethereum', label: 'Ethereum' },
 { value: 'solidity', label: 'Solidity' },
 { value: 'hyperledgerfabric', label: 'Hyperledger Fabric' },
 { value: 'truffle', label: 'Truffle' },
 { value: 'web3js', label: 'Web3.js' },
 { value: 'chainlink', label: 'Chainlink' },
 { value: 'cardano', label: 'Cardano' },
 { value: 'polkadot', label: 'Polkadot' },
 { value: 'binancesmartchain', label: 'Binance Smart Chain' },
 // IoT
 { value: 'mqtt', label: 'MQTT' },
 { value: 'coap', label: 'CoAP' },
 { value: 'amqp', label: 'AMQP' },
 { value: 'zigbee', label: 'Zigbee' },
 { value: 'zwave', label: 'Z-Wave' },
 { value: 'lorawan', label: 'LoRaWAN' },
 { value: 'iotplatforms', label: 'IoT platforms (e.g., ThingWorx, AWS IoT)' },
 // Game Development
 { value: 'unity', label: 'Unity' },
 { value: 'unrealengine', label: 'Unreal Engine' },
 { value: 'arcore', label: 'ARCore' },
 { value: 'arkit', label: 'ARKit' },
 { value: 'vuforia', label: 'Vuforia' },
 { value: 'blender', label: 'Blender' },
 // Quantum Computing
 { value: 'qiskit', label: 'Qiskit' },
 { value: 'microsoftquantumdevelopmentkit', label: 'Microsoft Quantum Development Kit' },
 { value: 'cirq', label: 'Cirq' },
 { value: 'rigettiforest', label: 'Rigetti Forest' },
 // Robotic Process Automation (RPA)
 { value: 'uipath', label: 'UiPath' },
 { value: 'blueprism', label: 'Blue Prism' },
 { value: 'automationanywhere', label: 'Automation Anywhere' },
 { value: 'workfusion', label: 'WorkFusion' },
 // Low-Code/No-Code Platforms
 { value: 'outsystems', label: 'OutSystems' },
 { value: 'mendix', label: 'Mendix' },
 { value: 'powerapps', label: 'PowerApps' },
 { value: 'bubble', label: 'Bubble' },
 { value: 'wappler', label: 'Wappler' },
 // Game Engines
 { value: 'godot', label: 'Godot' },
 { value: 'phaser', label: 'Phaser' },
 { value: 'cocos2d', label: 'Cocos2d' }
];